import { useEffect, useState } from 'react'
import { Configuration } from '../../models/types'

const useConfiguration = (instanceId?: string): Configuration => {
  const [current, setCurrent] = useState<Configuration>({})

  const handleChange = (e: CustomEvent): void => {
    if (instanceId) {
      e.detail.instanceId === instanceId && setCurrent(e.detail.value)
    } else {
      setCurrent(e.detail.value)
    }
  }

  useEffect(() => {
    document.addEventListener('retorik_configuration', (e) => handleChange(e))
    // Dispatch event on mount to get the updated value in stead of the default one
    document.dispatchEvent(new Event('retorik_call_configuration'))

    return () => {
      document.removeEventListener('retorik_configuration', (e) => handleChange(e))
    }
  }, [])

  return current
}

export default useConfiguration
